'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// /~/promise/index.js
// module id = A/Xc
// module chunks = 0